import qwest from 'qwest';
import events from '../lib/events';

qwest.setDefaultDataType('json');
qwest.setDefaultOptions({
  timeout: 75000,
});

qwest.raw = {
  get: qwest.get.bind(qwest),
  getOnline: qwest.get.bind(qwest),
  post: qwest.post.bind(qwest),
  put: qwest.put.bind(qwest),
  delete: qwest.delete.bind(qwest),
};

function wrapQwestFunc(qwestFunc, preventOfflineError = false) {
  return (...args) => {
    let qwestPromise = qwestFunc(...args);

    // Publish http-error event whenever an api call throws an error
    return qwestPromise.catch((xhr, response, error) => {
      if(xhr.message === 'Connection aborted' && preventOfflineError) {
        return qwestPromise;
      }

      console.log('publishing http-error');
      if (response.status === 401) {
        window.location.reload();
      }

      events.publish('http-error', {xhr, response, error});
      return qwestPromise;
    });
  };
}

qwest.get = wrapQwestFunc(qwest.raw.get);
qwest.getOnline = wrapQwestFunc(qwest.raw.getOnline, true);
qwest.post = wrapQwestFunc(qwest.raw.post);
qwest.put = wrapQwestFunc(qwest.raw.put);
qwest.delete = wrapQwestFunc(qwest.raw.delete);
